import { BaseAddress } from "../../fay/generated/api";

export type UserType = "Patient" | "Provider";

const userTypeMap: Record<string, UserType> = {
  client: "Patient",
  provider: "Provider",
};

export const currentUserType: UserType | undefined =
  userTypeMap[process.env.REACT_APP_FAY_APP!];

if (!currentUserType) {
  throw new Error(`Invalid app deployment: ${process.env.REACT_APP_FAY_APP}`);
}

export const formatAddress = (address: BaseAddress) => {
  const streetAddress = address.line2
    ? `${address.line1}, ${address.line2}`
    : address.line1;
  return `${streetAddress}, ${address.city}, ${address.state} ${address.postal_code}`;
};
